/* eslint-env browser, jquery */
import debugT from 'debug';
import container from 'modules/section-content';
import metrics from 'modules/metrics';
import domify from 'domify';
import page from 'modules/ab-page-js';
import tip from 'component-tip';
import rg from 'modules/npm-component/require-global';
import Batch from 'batch';
import _ from 'lodash';
import Sticky from 'headhesive';
import ContactForm from 'auth0-contact-form';
import abTesting from 'modules/ab-testing';
import splash from './pricing.pug';
import metadata from './metadata.json';
import PlansMeta from './models/plans-meta';
import FeaturesPartial from './partials/features/features-partial';
import PricingPartial from './partials/pricing-partial';
import addons from './data/addons.json';
import { getWinningVariant, abExperimentData, PRICING_WIZARD } from './abUtils';

const debug = debugT('auth0:pricing');

const metricsLib = window.metricsLib;
const mouseFlow = window.mouseflow || undefined;

const track = (eventName, props) => {
  debug('track', eventName, props);
  metrics.lib().track(
    eventName,
    _.extend(
      {
        category: 'pricing'
      },
      props
    )
  );
};

const featuresPartial = new FeaturesPartial({ track });

const pricingPartial = new PricingPartial({ featuresPartial, track });

const pricingWidgetUrl = '//cdn2.auth0.com/pricing-widget/pricing-widget-4.11.0.min.js';
const featureWidgetUrl = '//cdn2.auth0.com/js/feature-widget/feature-widget-1.11.3.min.js';

let stickyBanner;

export default function register() {
  // routing
  page('/pricing', loadScripts, render, renderPricing, renderFeatures, snippets);

  // TODO: Remove when pricing wizard calculator is finished
  page.exit('/pricing', destroySticky);
}

// route handlers
// page render!
function render(ctx, next) {
  // // TODO: Remove when pricing wizard calculator is finished
  const variant = getWinningVariant(ctx.winningVariants, PRICING_WIZARD);
  ctx.isPricingWizard = variant === abExperimentData[PRICING_WIZARD];

  const view = domify(
    splash({ planMeta: PlansMeta.load(), addons, isPricingWizard: ctx.isPricingWizard })
  );
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view })
  };
  container.render(renderOptions);

  if (!('ontouchstart' in window)) {
    $('[data-toggle="tooltip"]').tooltip();
  }

  next();
}

function loadScripts(ctx, next) {
  const batch = new Batch();

  abTesting.executeExperiment('show-prices-when-priced-annually', variant => {
    if (variant && variant.name === 'when-paid-annually') {
      window.pricingWidgetExperiment = 'when-paid-annually';
    }
  });

  pricingPartial.load(batch, pricingWidgetUrl);
  featuresPartial.load(batch, featureWidgetUrl);

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/pricing/resources/tooltips-a344d1455d.min.js', '$.fn.tooltips', done);
  });

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/pricing/resources/modal-3af0dc2fc3.min.js', '$.fn.modal', done);
  });

  batch.end(next);
}

function renderPricing(ctx, next) {
  pricingPartial.activate();
  pricingPartial.render();
  next();
}

function renderFeatures(ctx, next) {
  featuresPartial.activate();
  $('.js-plan-features-container').each(function() {
    const plan = this.getAttribute('data-plan');
    featuresPartial.render(plan);
  });
  // enable tooltips only in desktop view
  if (!('ontouchstart' in window)) {
    $('[data-toggle="tooltip"]').tooltip({ container: 'body' });
  }
  next();
}

function getModulesOffsets() {
  const modules = $('.pricing-module');
  const offsets = {};
  let count = 0;

  // Get all the plan groups in the page and asign them a data-sticky number
  modules.each((i, el) => {
    const $el = $(el);

    // Check if composite module
    if (!$el.hasClass('composite-module')) {
      const elName = $el.attr('data-pricing-category');
      $el.attr('data-sticky', count);
      offsets[elName] = $(el).offset().top;
      count += 1;
      return;
    }

    // add composite module
    const plans = $el.find('[data-plan-group]');

    plans.each((i, el) => {
      const elName = $(el).attr('data-plan-group');
      $(el).attr('data-sticky', count);
      offsets[elName] = $(el).offset().top;
      count += 1;
    });
  });

  return offsets;
}

// route handlers
// page snippets
function snippets(ctx, next) {
  const $featuresSwitch = $('.features-switch-cont');

  $(window).scroll();

  // Switch functionality
  $featuresSwitch.on('click', function(e) {
    $(this)
      .find('.active')
      .removeClass('active');
    $(e.target).addClass('active');
  });

  $('.switch-plan[data-view="fixed-plans"] .switch-item').click(ev => {
    ev.preventDefault();
    toggleSwitcher($('.switch-plan[data-view="fixed-plans"] .switch-item:not(.active)'));
  });

  $('.switch-plan[data-view="fixed-plans"] .switch-item').click(function(ev) {
    ev.preventDefault();
    if ($(this).hasClass('active')) return;
    toggleSwitcher(this);
  });

  tip('.package-plan-tip');

  $('.js-general-contact-sales').click(() => {
    track('click:contact-sales');
  });

  // Developer Pro Internal-External Switch
  $(".plan-usage-toggle input[type='radio']").change(function() {
    const value = $(this).val();
    $('.developer-pro-external,.developer-pro-internal').toggleClass('hide', true);
    $(`.developer-pro-${value}`).toggleClass('hide', false);
    $('[name="usage"]').prop('checked', false);
    $(`[name="usage"][value="${value}"]`).prop('checked', function() {
      return $(this)
        .parent()
        .is(':visible');
    });
  });

  contactFormModals();

  // TODO: Remove when pricing wizard calculator is finished
  stickyCalculatorBanner(ctx.isPricingWizard);
  next();
}

// TODO: Remove when pricing wizard calculator is finished

function destroySticky(ctx, next) {
  if (!stickyBanner) {
    return next();
  }

  stickyBanner.destroy();
  return next();
}

function toggleSwitcher(el) {
  if ($(el).hasClass('active')) return;

  // toggle buttons
  $('.switch-plan[data-view="fixed-plans"] .switch-item').removeClass('active');
  $(el).addClass('active');

  pricingPartial.setRecurrence($(el).data('interval'));
}

function stickyCalculatorBanner(isPricingWizard) {
  if (isPricingWizard) {
    if (!$('#calculator_banner_sticky').length) return;
    // Pricing Calculator Banner functionality
    stickyBanner = new Sticky('#calculator_banner_sticky', {
      offset: '#calculator_banner_sticky:not(.banner--clone)',
      offsetSide: 'bottom',
      classes: {
        clone: 'banner--clone',
        stick: 'banner--stick'
      },
      onInit: function init() {
        $([this.elem, this.clonedElem]).on('click', () => {
          track('click:pricing:try-wizard');
        });
        $(this.clonedElem)
          .find('.calculator-close-btn')
          .on('click', e => {
            e.preventDefault();
            destroySticky();
          });
      },
      onDestroy: () => {
        stickyBanner = null;
      }
    });
  }
}

function contactFormModals() {
  // Contact Sales Form
  const salesContactFormOptions = {
    onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:pricing-contact-form', metricsData);
      mouseFlow ? mouseFlow.formSubmitSuccess('#contact-form-modal__form') : null;
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:pricing-contact-form', metricsData);
      mouseFlow ? mouseFlow.formSubmitFailure('#contact-form-modal__form') : null;
    },
    source: 'pricing-page'
  };
  const salesContactForm = new ContactForm(salesContactFormOptions);

  $('.open-contact-form-modal').click(() => salesContactForm.show({ includePhoneField: true }));

  // Contact OSS Form
  const ossContactFormOptions = {
    onModalOpen() {
      metricsLib.track('click:contact-oss');
    },
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:pricing-contact-form-oss', metricsData);
      mouseFlow ? mouseFlow.formSubmitSuccess('#contact-form-modal__form') : null;
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:pricing-contact-form-oss', metricsData);
      mouseFlow ? mouseFlow.formSubmitFailure('#contact-form-modal__form') : null;
    },
    modalTitle: 'Contact OSS team',
    source: 'oss'
  };
  const ossContactForm = new ContactForm(ossContactFormOptions);

  $('.open-contact-oss').click(() => ossContactForm.show({ includePhoneField: true }));
}



// WEBPACK FOOTER //
// ./src/pages/pricing/pricing.js